import React from 'react';
import cn from 'classnames';

import styles from './Laser.module.css';

const Laser = ({ animate }) => (
  <div className={cn(styles.laserWrapper, 'absolute inset-0', { [`${styles.animate}`]: animate })}>
    <div className={`${styles.laserOpacity} hidden`}>
      <div className={`${styles.laser} absolute top-0 left-0 right-0 z-10`} />
    </div>
  </div>
);

export default Laser;
